// extracted by mini-css-extract-plugin
module.exports = {"label":"input_label__EXcTt","wrapper":"input_wrapper__QJnoC","preview":"input_preview__2Yb-K"};